// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"616167a5","149":"3f0f6e23","188":"fa9c6f64","381":"53ab74a3","398":"4201bdff","438":"6af37aaf","453":"2c883477","545":"ef3d2052","638":"f6efb290","726":"a6fea895","834":"3b81034b","871":"ee95fb08","937":"289c634d"}[chunkId] + ".chunk.js";
};